// src/components/products/ProductForm/TourDetailsSections/TourHighlightsSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const TourHighlightsSection = ({
    formData,
    errors,
    activeLang,
    handleMultiLangChange,
}) => {
    const showArabic = activeLang === "ar";
    const showEnglish = activeLang === "en";

    return (
        <Grid container spacing={3}>
            {/* Highlights - Arabic */}
            {showArabic && (
                <Grid item xs={12}>
                    <FormInput
                        label="أبرز المعالم (عربي)"
                        type="editor"
                        textareaRows={200}
                        name="highlights_ar"
                        value={formData.highlights?.ar || ''}
                        onChange={(e) => handleMultiLangChange('highlights', 'ar', e.target.value)}
                        rows={3}
                        error={!!errors.highlights_ar}
                        helperText={errors.highlights_ar}
                    />
                </Grid>
            )}

            {/* Highlights - English */}
            {showEnglish && (
                <Grid item xs={12}>
                    <FormInput
                        label="Highlights (English)"
                        type="editor"
                        textareaRows={200}
                        name="highlights_en"
                        value={formData.highlights?.en || ''}
                        onChange={(e) => handleMultiLangChange('highlights', 'en', e.target.value)}
                        rows={3}
                        error={!!errors.highlights_en}
                        helperText={errors.highlights_en}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default TourHighlightsSection;
